import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { IDropdownItem, UserSettingsBase } from '../../models';
import { UserService } from '../../services';

@Component({
  selector: 'app-general-settings',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
  standalone: true,
  imports: [DropDownListModule, FormsModule]
})
export class GeneralSettingsComponent extends UserSettingsBase {
  public dateformats: Array<IDropdownItem> = [
    { text: "dd MMM yyyy (20 Mar 2020)", value: "dd MMM yyyy" },
    { text: "dd/MM/yyyy (20/03/2020)", value: "dd/MM/yyyy" },
    { text: "MM/dd/yyyy (03/20/2020)", value: "MM/dd/yyyy" },
  ];

  settingsModel: any = { dateFormat: undefined };

  constructor(private settingsService: UserService) {
    super();
  }

  ngOnInit(): void {
    const settings: { [key: string]: any } = this.settingsService.getSettings();
    const settingskeys: string[] = Object.keys(settings);

    if (settingskeys.includes("general.dateformat")) {
      const item = this.dateformats.find(f => f.value == settings["general.dateformat"]);
      this.settingsModel.dateFormat = item;
    }
    else {
      this.settingsService.updateSetting('general.dateformat', 'dd MMM yyyy');
      this.settingsService.saveSettingsChanges();
      const item = this.dateformats.find(f => f.value == 'dd MMM yyyy');
      this.settingsModel.dateFormat = item;
    }
  }

  public dateValueChange(_value: any, _cid: string): void {
    this.settingsService.updateSetting('general.dateformat', this.settingsModel.dateFormat?.value);
    this.isDirty = true;
  }

  save() {
    // Save dateformat
    this.settingsService.saveSettingsChanges();
  }

  cancel() {
    this.settingsService.cancelSettingsChanges();
  }
}
